// AssumptionsStrip.js — Always-visible assumptions digest strip with guardrails
import React from 'react';
import { BANNED_WORDS } from '../../lib/projections/constants';

/**
 * Scan text for banned words and return cleaned version.
 * @param {string} text
 * @returns {string}
 */
function sanitize(text) {
  let clean = text;
  BANNED_WORDS.forEach(word => {
    const regex = new RegExp(`\\b${word}\\b`, 'gi');
    clean = clean.replace(regex, '[redacted]');
  });
  return clean;
}

/**
 * Always-visible strip showing all active assumptions in plain language.
 * @param {{ assumptions: string[] }} props
 */
const AssumptionsStrip = ({ assumptions = [] }) => {
  if (!assumptions || assumptions.length === 0) return null;

  return (
    <div className="bg-zinc-100 border border-zinc-200 rounded-none p-4 mt-4" role="region" aria-label="Projection assumptions">
      <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-zinc-500 mb-2">
        Assumptions
      </p>
      <ul className="space-y-1">
        {assumptions.map((a, i) => (
          <li key={i} className="text-[11px] text-zinc-600 font-mono leading-relaxed">
            {sanitize(a)}
          </li>
        ))}
      </ul>
      <p className="text-[11px] text-zinc-500 font-mono mt-3 border-t border-zinc-200 pt-2 italic">
        This is an illustration, not a forecast.
      </p>
    </div>
  );
};

export default AssumptionsStrip;
